import './ModalFileUpload.scss';

import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';

import Icon from 'components/Icon';

export default class ModalFileUpload extends React.Component {
    static propTypes = {
        accept: PropTypes.string.isRequired,
        fileToUpload: PropTypes.object,
        generatePreview: PropTypes.func.isRequired,
        handleFileDrop: PropTypes.func.isRequired,
        hasFile: PropTypes.bool.isRequired,
        instructionsText: PropTypes.string
    };

    render() {
        let { accept, fileToUpload, generatePreview, handleFileDrop, hasFile } = this.props;
        return (
            <div className="modal__file-upload">
                <Dropzone accept={accept}
                          className="modal__dropzone"
                          multiple={false}
                          onDrop={handleFileDrop.bind(this)}>
                    {fileToUpload == null && hasFile !== true ? (
                        <div className="modal__dropzone-instructions">
                            <Icon icon="upload" />
                            {this.props.instructionsText || 'Click or drag files here to upload.'}
                        </div>
                    ) : generatePreview()}
                </Dropzone>
                <div className="thumbnail-drop__progress--overlay">
                    <div className="thumbnail-drop__progress--outer">
                        <div id="thumbnailProgress" className="thumbnail-drop__progress--inner"></div>
                    </div>
                    <div className="thumbnail-drop__progress--done">
                        <Icon icon="check" />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ModalFileUpload/index.js